import React, { useState, useContext } from "react";
import "../../../../ui-styles/list/contactListAction.css";
import "../../Styles.css";
import "../../../../ui-styles/inlineLink/inlineLinkIcon.css";
import PatientProfileSlide from "./PatientProfileSlide";
import DeletePatientModal from "./DeletePatientModal";
import { useHistory } from 'react-router-dom';
import { deletePatient } from "../../../../actions/users";
import { Link } from "react-router-dom";
import { LangCtx } from "../../../../lib/context";
import VerifyPopup from "../../../admin/users/components/VerifyPopup";
import Button from "../../../../lib/ui/buttons/Button";

const PatientsListItems = (props) => {
    const { l } = useContext(LangCtx);
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const { data } = props;
    const [openDelete, setOpenDelete] = useState(false)
    const [openPopup, setopenPopup] = useState(false)
    const [verify, setVerify] = useState(data.verify);

    const handleVerify = () => {
        setVerify(prevState => !prevState);
        setopenPopup(prevState => !prevState);
    }

    const handlePopup = () => {
        setopenPopup(prevState => !prevState);
    }

    const handleSlide = () => {
        setOpen(prevState => !prevState);
    }
    const handleEdit = (patient) => {
        history.push(`/create-patient/${data.userId}`)
    }

    const handleOpen = () => {
        setOpenDelete(prevState => !prevState);
    }

    const handleDelete = () => {
        //  setLoading(true);
        deletePatient({ username: props.data.userId }).then(res => {
            //    setLoading(false);
            if (res && res.status) {
                props.reloadData();
            }
        }).catch(err => {
            //    setLoading(false);
            console.log("err ==== ", err);
        })
    }

    return <li className="cntcListItem Md" key={data.userId}>
        <div className="cntcListAvtr Md">
            {data.profilePic ?
                <img src={data.profilePic} alt="avatar" />
                :
                <div className="roundimg">{data.firstName.charAt(0)}</div>
            }
        </div>
        <div className="cntcListContent" onClick={handleSlide}>
            <span className="elslistTxtL">{data.firstName ? data.firstName : ''}</span>
            <div className="rowBlock alignCenter">
                <span className="elslistTxtM">{data.phone ? data.phone : ''}</span>
                {verify && verify === true ?
                    <div className="actionItem noHover" tooltip="Verified">
                        <img src="/images/icons/verified.png" alt="icon" />
                    </div>
                    :
                    <div className="mrgLeft8">
                        <Button
                            label={l.vfy}
                            type='outLine'
                            size='xs'

                            onClick={() => { handlePopup() }}
                        />
                    </div>}
            </div>
            <span className="elslistTxtM">{data.gender ? data.gender : ''}</span>
            <div className="showInRes mrgTop8">
                <Link className="inlineLink Sm" to="/create-patient"><span>{l.book_apptmnt}</span></Link>
            </div>

        </div>
        <div className="cntcListAction">
            <div className="showInWeb">
                <Link className="inlineLink Sm" to={`/doctor-schedule/${data.userId}`}><span>{l.book_apptmnt}</span></Link>
            </div>
            <div className="actionItem" onClick={() => handleEdit(data)}>
                <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
            </div>
            <div className="actionItem" onClick={handleOpen}>
                <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
            </div>

        </div>
        {open && <PatientProfileSlide open={open} handleSlide={handleSlide} closeSlide={handleSlide} data={data} />}
        {openDelete && <DeletePatientModal handleDelete={handleDelete} openDelete={openDelete} closeDelete={handleOpen} patientItem={data} />}
        {openPopup &&
            <VerifyPopup openVerify={openPopup} closePopup={handlePopup} handleVerify={handleVerify} phone={data.phone} />}
    </li>
}
export default React.memo(PatientsListItems);